import { withRouter } from 'react-router';
import * as React from 'react';
import Footer from '../App/components/Layout/Footer/Footer';
import Header from '../App/components/Layout/Header/Header';
import MainNavigation from '../App/components/Layout/MainNavigation/MainNavigation';
import withRouteMetadata from '../App/hocs/withRouteMetadata';
import { IRouteMetadataType } from '../App/modules/Base/types/IRouteMetadataType';
import PromotionsInProductGroupAndVendor
	from '../App/modules/Promotion/components/PromotionsInProductGroupAndVendor/PromotionsInProductGroupAndVendor';
import {
	pluralizerPromotionsAndSpecials,
	maxDiscountInTitle,
	withTitlePostfix,
	withClickbait,
	currentEntryWord
} from '../App/utils/routeMetadataUtils';
import BaseRoute from './_BaseRoute';
import FlexWrapper from '../App/components/Layout/Flexbox/FlexWrapper';
import AdItem from '../App/components/General/AdItem/AdItem';
import AdConfigContainer from '../App/components/General/AdConfig/AdConfigContainer';
// import withVendor from '../App/modules/Vendor/hocs/withVendor';


interface IPromotionsInProductGroupAndVendorRouteProps {
	match: {
		params: {
			query: {
				vendor: string;
				productGroup: string,
			}
		}
	}
}
class PromotionsInProductGroupAndVendorRoute extends BaseRoute<IPromotionsInProductGroupAndVendorRouteProps> {
	public static async getInitialProps(state: any) {
		const reduxData = await PromotionsInProductGroupAndVendorRouteProps(state);

		return { reduxData };
	}
	public render() {
		const query = (this.props.match.params) ? this.props.match.params : {};

		return (
			<React.Fragment>

				<AdConfigContainer
					slug={query.vendor}
					desktopIds={[4403491]}
					mobileIds={[4403480, 4403479]}
					superbannerId={4403492}
					sitebarId={4403490}
				/>

				<Header />
				<MainNavigation />

				<FlexWrapper>
					<div>

						<PromotionsInProductGroupAndVendor
							productGroupSlug={query.productGroup}
							vendorSlug={query.vendor}
							{...this.props}
						/>
						{/* {withVendor(
							PromotionsInProductGroupAndVendor,
							query.vendor,
							{
								...this.props,
								productGroupSlug: query.productGroup,
								vendorSlug: query.vendor,
							}
						)} */}

						<Footer />
					</div>

					<AdItem
						desktopAdId={4403490}
						maxHeight={600}
						maxWidth={300}
						type="side"
						className="startBelowMenuBar"
					/>
				</FlexWrapper>

			</React.Fragment>
		);
	}
}

export default withRouter(
	withRouteMetadata(
		PromotionsInProductGroupAndVendorRoute,
		(props: any) => `ppcv-${props.match.params.productGroup}-${props.match.params.vendor}`,
		{
			pageTitle: (routeMetadata: IRouteMetadataType) =>
				`${routeMetadata.totalItemsCount || ''} ${currentEntryWord(routeMetadata.totalItemsCount, 'aktuelle', 'aktuelle')} ${routeMetadata.productGroup.title} ${pluralizerPromotionsAndSpecials(routeMetadata.totalItemsCount)} bei ${routeMetadata.vendor.title}`,
			metaTitle: (routeMetadata: IRouteMetadataType) =>
				withTitlePostfix(`${routeMetadata.totalItemsCount || ''} ${routeMetadata.productGroup.title} ${pluralizerPromotionsAndSpecials(routeMetadata.totalItemsCount)} bei ${routeMetadata.vendor.title.toUpperCase()} ${maxDiscountInTitle(routeMetadata.maxItemDiscount)}`),
			metaDescription: (routeMetadata: IRouteMetadataType) =>
				withClickbait(`Aktuelle Angebote und Aktionen aus der Kategorie ${routeMetadata.productGroup.title} bei ${routeMetadata.vendor.title.toUpperCase()} » Preiskracher ermitteln ✓ Rabatt sichern`, `✓ Jetzt mehr erfahren!`),
		} as IRouteMetadataSetterType,
	),
);

